import RotatingBanner from './RotatingBanner';

export default RotatingBanner;
